<svelte:options customElement={{
  tag: 'button-element',
  shadow: 'none',
  props: {
    href: { reflect: true, type: 'String' },
    label: { reflect: true, type: 'String' },
    variant: { reflect: true, type: 'String' },
    appearance: { reflect: true, type: 'String' },
    icon: { reflect: true, type: 'String' },
    iconposition: { reflect: true, type: 'String' },
    align: { reflect: true, type: 'String' },
    disabled: { reflect: true, type: 'Boolean' },
    target: { reflect: true, type: 'String' },
  }
}} />

<script>
  import SvgIcon from '../SvgIcon.svelte';

  /**
   * ボタン
   * パーツライブラリ準拠のボタンコンポーネント
   * @prop {string} href - リンク先URL
   * @prop {string} label - ボタンテキスト
   * @prop {string} variant - バリアント:
   *   'primary' (mod-button), 'secondary' (mod-button02), 'tertiary' (mod-button03),
   *   'functional' (mod-button-fn), 'functional-secondary' (mod-button-fn02),
   *   'functional-tertiary' (mod-button-fn03),
   *   'circle' (mod-circle-arrow), 'kv' (mod-kv-btn)
   * @prop {string} appearance - 外観: 'default', 'on-dark' (_white), 'on-brand' (_on-brand)
   * @prop {string} icon - アイコン名（SvgIcon の name に準拠）:
   *   'arrow_right_circle', 'blank', 'pdf', 'download', 'contact', 'search' 等
   * @prop {string} iconposition - アイコン位置: 'right' (default), 'left'
   * @prop {string} align - 配置: 'left', 'center', 'right'
   * @prop {boolean} disabled - 無効化状態（is-disabled クラス付与、aria-disabled 設定）
   * @prop {string} target - リンクのターゲット属性（例: '_blank'）
   */
  export let href = '#';
  export let label = 'Button';
  export let variant = 'primary';
  export let appearance = 'default';
  export let icon = '';
  export let iconposition = 'right';
  export let align = 'center';
  export let disabled = false;
  export let target = '_self';

  const variantMap = {
    'primary': 'mod-button',
    'secondary': 'mod-button02',
    'tertiary': 'mod-button03',
    'functional': 'mod-button-fn',
    'functional-secondary': 'mod-button-fn02',
    'functional-tertiary': 'mod-button-fn03',
    'circle': 'mod-circle-arrow',
    'kv': 'mod-kv-btn',
    // 後方互換
    'default': 'mod-button',
    'accent': 'mod-button02'
  };

  const appearanceMap = {
    'on-dark': '_white',
    'on-brand': '_on-brand'
  };

  $: isCircle = variant === 'circle';
  $: isKv = variant === 'kv';
  $: hasIcon = !!icon;

  $: buttonClass = [
    variantMap[variant] || 'mod-button',
    appearance !== 'default' ? (appearanceMap[appearance] || '') : '',
    align ? `_${align}` : '',
    disabled ? 'is-disabled' : '',
    !isCircle && !isKv && hasIcon ? `_icon-${iconposition}` : ''
  ].filter(Boolean).join(' ');

</script>

{#if isCircle}
  <div class="mod-button-wrap">
    <a {href} class={buttonClass} aria-disabled={disabled || undefined} target={target || undefined}>
      <SvgIcon name={icon || 'arrow_right_circle'} size="lg" />
    </a>
  </div>
{:else if isKv}
  <div class="mod-button-wrap">
    <a {href} class={buttonClass} aria-disabled={disabled || undefined} target={target || undefined}>
      <span class="_text">{label}</span>
      <span class="_icon">
        <SvgIcon name={icon || 'arrow_right_circle'} size="lg" />
      </span>
    </a>
  </div>
{:else}
  <div class="mod-button-wrap">
    <a {href} class={buttonClass} aria-disabled={disabled || undefined} target={target || undefined}>
      {#if hasIcon && iconposition === 'left'}
        <span class="_icon">
          <SvgIcon name={icon} size="lg" />
        </span>
      {/if}
      <span class="_text">{label}</span>
      {#if hasIcon && iconposition !== 'left'}
        <span class="_icon">
          <SvgIcon name={icon} size="lg" />
        </span>
      {/if}
    </a>
  </div>
{/if}
